import { parseFloatToDecimals, parseFloatUniversal } from "../utils/numberUtils";
export var TableFieldType;
(function (TableFieldType) {
    TableFieldType["f"] = "f";
    TableFieldType["s"] = "s";
    TableFieldType["i"] = "i";
    TableFieldType["tdt_s"] = "tdt_s";
})(TableFieldType || (TableFieldType = {}));
export function convertValueToFieldType(value, type) {
    switch (type) {
        case TableFieldType.f:
            return parseFloatToDecimals(value, 2);
        case TableFieldType.i:
            return parseFloatUniversal(value);
        case TableFieldType.s:
            return '' + value;
        case TableFieldType.tdt_s:
            return new Date(value);
    }
    return value;
}
